import React from "react";
import { RADIAN } from "@constants/radian";

type ChartLabelProps = {
  cx: number;
  cy: number;
  midAngle: number;
  innerRadius: number;
  outerRadius: number;
  percent: number;
  index: number;
  value: string | number;
};

function ChartLabel({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
}: ChartLabelProps) {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    />
  );
}

export default ChartLabel;
